export const displayValue = (val: string | number | null | undefined, unit?: string): string => {
	if (val === null || val === undefined || val === "") return "—";
	return unit ? `${val} ${unit}` : `${val}`;
};

export const hasAnyValue = (values: Array<string | number | null | undefined>): boolean =>
	values.some((val) => val !== null && val !== undefined && val !== "");
